export enum Constants {
  SET_SPORT = '@shared/set_sport',
  SET_SITE = '@shared/set_site',
  SET_TYPE = '@shared/set_type',
  SET_SLATE = '@shared/set_slate',
  SET_APP = '@shared/set_app',
  SET_DISPLAYED_SLATE = '@shared/set_displayed_slate',
  SET_AUTH = '@shared/set_auth',
  SET_PLAYER_EXPOSURES = '@shared/set_player_exposures',
  SET_STACK_EXPOSURES = '@shared/set_stack_exposures',
  SET_REMOVED_TEAMS = '@shared/set_removed_teams',
  SET_BOOSTED_TEAMS = '@shared/set_boosted_teams',
  SET_UNIQUE_LIMIT = '@shared/set_unique_limit',
}